module.exports = __webpack_public_path__ + "img/5930c1a.jpg";